<template>
  <v-container class="main-supplier-select mainWrapElements">
    <img
      v-if="instance.linktree_logo"
      class="mx-auto linktree-logo"
      :src="instance.linktree_logo.thumb"
    />
    <div v-else class="layout-img-logo" />
    <div class="scrollMobileFix">
      <v-row class="linktree mainWrapBtns">
        <v-col
          :class="['wrapBtn', 'service_delivery_custom']"
          v-if="instance.slug === 'the-grill-station-burger'"
        >
          <v-btn
            class="itemBtn"
            large
            block
            @click="execILink('service_delivery')"
          >
            <img
              src="https://images.cluvi.com/oIG7GxCwFh/thumb_oIG7GxCwFh_moto-domi.png"
              alt=""
              class="img-left"
            />
            Domicilios
            <img
              src="https://images.cluvi.com/zTh9bOeHEp/thumb_zTh9bOeHEp_moto-domi-2.png"
              class="img-right"
            />
          </v-btn>
        </v-col>
        <v-col
          :class="['wrapBtn', 'service_delivery_custom']"
          v-if="instance.slug === 'one-dog'"
        >
          <img
            src="https://images.cluvi.com/nL6a5ArvvX/w_768_nL6a5ArvvX_boton-1.png"
            alt=""
            class="button-deliver-img"
            @click="execILink('service_delivery')"
          />
        </v-col>
        <v-col
          v-for="item in customerLinktree"
          :key="item.url != null && item.url != '' ? item.url : item.target"
          :class="['wrapBtn', item.target]"
        >
          <v-btn
            v-if="
              (item.url != '' && item.target === '_blank') ||
                item.target === '_self'
            "
            class="itemBtn"
            link
            large
            block
            :href="item.url"
            :target="item.target"
            v-html="item.label"
            @click="sendEventLinktree(item.label)"
          />
          <v-btn
            v-else
            class="itemBtn"
            large
            block
            @click="execILink(item.target)"
            :data-testid="`Main-` + item.target"
          >
            {{
              item.label_custom &&
              item.label_custom !== null &&
              item.label_custom !== ""
                ? item.label_custom
                : getLabelTranslation(item)
            }}
          </v-btn>
        </v-col>
        <v-col v-if="instance.linktree_add_suppliers" class="wrapBtn">
          <v-btn
            v-if="
              instance.labels_buttons.nuestras_tiendas !== undefined &&
                instance.labels_buttons.nuestras_tiendas.toString().length > 0
            "
            class="itemBtn"
            large
            block
            @click="goToBranches()"
            v-html="instance.labels_buttons.nuestras_tiendas"
          />
          <v-btn
            v-else
            class="itemBtn"
            large
            block
            @click="goToBranches()"
            v-html="$t('common.nuestras_tiendas')"
          />
        </v-col>
        <v-col
          v-if="instance.slug === 'semolina' || instance.slug === 'patria'"
          class="py-0 mt-0"
          cols="12"
          sm="6"
          offset-sm="3"
        >
          <v-btn
            class="mt-2"
            large
            block
            v-html="$t('contact_us')"
            @click="goToBranchesWhatsapp()"
          />
        </v-col>
      </v-row>
      <social-networks :instance="instance" />
    </div>

    <!-- La dirección guardada se ofrece aquí y no dentro del asistente: en el
         linktree todavía se puede decidir no pedirla. -->
    <saved-address-dialog
      :value="savedAddressDialog"
      :address="location.address"
      :addressOptional="location.address_optional"
      :startsWithoutAddress="startsWithoutAddress"
      @confirm="confirmSavedAddress"
      @dismiss="dismissSavedAddress"
    />

    <branch-closed-alert
      :value="branchClosedAlert"
      :label="closedBranchLabel"
      :canSchedule="canSchedule"
      :canTakeAway="canTakeAway"
      :canChangeAddress="false"
      @schedule="scheduleOnClosedBranch"
      @takeAway="takeAwayOnClosedBranch"
      @continueAnyway="continueToClosedBranch"
    />

    <transition enter-active-class="fadeInDown" leave-active-class="fadeOutUp">
      <div v-if="noDeliveryAlert" class="delivery-modalMap">
        <div class="delivery-modalMapInner">
          <b
            class="title"
            v-html="$t('DELIVERY.LOCATION.no_active_delivery')"
          />
          <button
            class="delivery-btnAddress"
            v-html="$t('common.close_button_label')"
            @click="noDeliveryAlert = false"
          />
        </div>
      </div>
    </transition>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { track } from "@/services/track-custom";
import {
  COVERAGE_STATUS,
  isBranchClosed,
  resolveCoverage
} from "@/services/coverage";
import {
  branchFromCoverage,
  nearestBranchEntry,
  trackBranchAssigned
} from "@/services/branchEntry";

/**
 * Una vez por visita.
 *
 * Todo el flujo de domicilios parte de pulsar "Domicilios" en el linktree, así
 * que aquí es donde se cuenta. `sessionStorage` es la medida exacta de "visita":
 * sobrevive a las recargas y a la navegación dentro de la app, y se borra al
 * cerrar la pestaña. En navegación privada puede lanzar al leer, y entonces se
 * pregunta otra vez, que es el error tolerable de los dos.
 */
const SAVED_ADDRESS_OFFERED_KEY = "cluvi.saved_address_offered";

const savedAddressAlreadyOffered = () => {
  try {
    return window.sessionStorage.getItem(SAVED_ADDRESS_OFFERED_KEY) === "1";
  } catch (error) {
    return false;
  }
};

const rememberSavedAddressOffered = () => {
  try {
    window.sessionStorage.setItem(SAVED_ADDRESS_OFFERED_KEY, "1");
  } catch (error) {
    error;
  }
};

export default {
  name: "Main",
  components: {
    SocialNetworks: () =>
      import(
        /* webpackChunkName: "SocialNetworks" */ "@/components/common/SocialNetworks.vue"
      ),
    SavedAddressDialog: () =>
      import(
        /* webpackChunkName: "SavedAddressDialog" */ "@/components/delivery/SavedAddressDialog.vue"
      ),
    BranchClosedAlert: () =>
      import(
        /* webpackChunkName: "BranchClosedAlert" */ "@/components/delivery/BranchClosedAlert.vue"
      )
  },
  data: () => ({
    modalGps: false,
    savedAddressDialog: false,
    branchClosedAlert: false,
    noDeliveryAlert: false,
    closedBranch: null
  }),
  created() {
    this.TemplateDisableHeader();
    this.SetAppClass("background-app");
    this.setService("");
    this.linkInstance();
    this.routeToUrl();
  },
  computed: {
    ...mapState("customer", ["instance"]),
    ...mapState("profile", ["location"]),
    ...mapGetters("customer", ["getLabels", "startsWithoutAddress"]),
    customerLinktree() {
      return this.instance?.linktree || [];
    },
    hasSavedAddress() {
      return !!this.location?.address;
    },
    closedBranchLabel() {
      return this.closedBranch?.label || "";
    },
    canSchedule() {
      return !!this.closedBranch?.service_schedule;
    },
    canTakeAway() {
      return !!this.closedBranch?.service_take_away;
    }
  },
  methods: {
    ...mapMutations("template", [
      "SetLoading",
      "TemplateDisableHeader",
      "SetAppClass"
    ]),
    ...mapMutations("order", [
      "setService",
      "SetPurchaseId",
      "SetTaPurchaseId",
      "SetOtPurchaseId",
      "setShoppingCart",
      "SetTotalShoppingCart"
    ]),
    ...mapMutations("profile", ["setAllowGps", "setLocation"]),
    ...mapMutations("customer", [
      "SetIsPreview",
      "SetPolygon",
      "SetSupplierSource"
    ]),
    ...mapMutations("ontable", ["setCountProductsOrdered"]),
    ...mapActions("order", ["setSchedule", "setDelivery", "setTakeAway"]),
    goToBranchesWhatsapp() {
      this.sendEventLinktree("BranchWhatsapp");
      this.$router.push({ name: "BranchWhatsapp" });
    },
    goToBranches() {
      this.sendEventLinktree("Branch");
      this.$router.push({ name: "Branch" });
    },
    execDelivery() {
      this.setDelivery();
      this.startDeliveryFlow();
    },
    execBook() {
      this.$router.push({ name: "BranchToBook" });
    },
    execOnTable() {
      this.$router.push({ name: "BranchOnTable" });
    },
    execTakeAway() {
      this.setTakeAway();
      this.$router.push({ name: "BranchToTakeAway" });
    },
    execSchedule() {
      this.setSchedule();
      this.startDeliveryFlow();
    },
    /**
     * Las tres maneras de empezar un domicilio, en orden.
     *
     * Con una dirección guardada se pregunta por ella —una vez por visita— antes
     * que nada: es la que el cliente ya usó. Sin ella, la bandera de la cuenta
     * decide si se entra al menú de una sede o se pide la dirección primero, que
     * es como funcionó siempre.
     */
    startDeliveryFlow() {
      if (this.hasSavedAddress) {
        if (savedAddressAlreadyOffered()) {
          this.goToCoveringBranch();
          return;
        }
        rememberSavedAddressOffered();
        this.savedAddressDialog = true;
        track.trackEventCluvi({}, "saved address offered");
        return;
      }
      if (this.startsWithoutAddress) {
        this.enterWithoutAddress();
        return;
      }
      this.$router.push({ name: "SetLocation" });
    },
    confirmSavedAddress() {
      this.savedAddressDialog = false;
      track.trackEventCluvi({}, "saved address accepted");
      this.goToCoveringBranch();
    },
    /**
     * El cliente no quiere esa dirección, así que deja de ser suya.
     *
     * Conservarla sería peor que no tenerla: el carrito cobraría el domicilio y
     * el precheckout la daría por buena sin que el cliente la haya elegido. La
     * sede sí se conserva —descartar una dirección no es quedarse sin sede—,
     * igual que hace "buscar otra dirección" dentro del asistente.
     */
    dismissSavedAddress() {
      this.savedAddressDialog = false;
      this.setLocation({});
      this.SetPolygon({});
      if (this.startsWithoutAddress) {
        track.trackEventCluvi({}, "saved address skipped");
        this.enterWithoutAddress();
        return;
      }
      track.trackEventCluvi({}, "saved address replaced");
      this.$router.push({ name: "SetLocation" });
    },
    enterWithoutAddress() {
      track.trackEventCluvi({}, "delivery start without address");
      this.enterByNearestBranch();
    },
    /**
     * Se resuelve la cobertura aquí, antes de navegar.
     *
     * Podría dejarse para el home —`coverageMixin` la resuelve al montar—, pero
     * entonces el cliente aterrizaría en una sede elegida por el orden de la
     * cuenta y vería el modal de cambio de sede encima de un menú que no le
     * tocaba. Resolverla aquí no agrega una petición: mueve la que el home iba a
     * hacer de todos modos, y al llegar con el polígono puesto el mixin
     * cortocircuita.
     */
    async goToCoveringBranch() {
      this.SetLoading(true);
      const { status, data } = await resolveCoverage(
        this.location.latitude,
        this.location.longitude
      );

      const branch =
        status === COVERAGE_STATUS.COVERED
          ? branchFromCoverage(
              this.instance.suppliers_delivery,
              data.supplier_id
            )
          : null;

      // Sin cobertura, sin respuesta, o con una sede que la cuenta ya no publica:
      // se entra por la más cercana y el home vuelve a intentarlo.
      if (!branch) {
        this.enterByNearestBranch();
        return;
      }

      if (isBranchClosed(data)) {
        this.closedBranch = branch;
        this.branchClosedAlert = true;
        this.SetLoading(false);
        track.trackEventCluvi(
          { supplier_id: branch.id },
          "set location.branch closed on coverage"
        );
        return;
      }

      this.SetSupplierSource({ source: "coverage", supplier_id: branch.id });
      this.SetPolygon({
        ...data,
        coordinates: {
          latitude: this.location.latitude,
          longitude: this.location.longitude
        }
      });
      trackBranchAssigned(branch, "coverage", null);
      this.goHome(branch.slug);
    },
    // El mismo respaldo que "omitir este paso": la sede más cercana a la
    // dirección, o el orden de la cuenta cuando no hay dirección con qué medir.
    enterByNearestBranch() {
      const entry = nearestBranchEntry(
        this.instance.suppliers_delivery,
        this.location
      );

      if (!entry) {
        this.noDeliveryAlert = true;
        this.SetLoading(false);
        return;
      }

      this.SetSupplierSource({
        source: entry.source,
        supplier_id: entry.branch.id
      });
      trackBranchAssigned(entry.branch, entry.source, entry.distance);
      this.goHome(entry.branch.slug);
    },
    // Programar no necesita que la sede esté abierta ahora: la consulta de
    // cobertura de `schedule` acepta los polígonos sin entrega inmediata.
    scheduleOnClosedBranch() {
      track.trackEventCluvi(
        { supplier_id: this.closedBranch?.id },
        "set location.branch closed schedule"
      );
      this.branchClosedAlert = false;
      this.setSchedule();
      this.goToCoveringBranch();
    },
    takeAwayOnClosedBranch() {
      track.trackEventCluvi(
        { supplier_id: this.closedBranch?.id },
        "set location.branch closed take away"
      );
      this.branchClosedAlert = false;
      this.setTakeAway();
      this.goHome(this.closedBranch?.slug);
    },
    // Se entra a ver el menú, pero sin adoptar el polígono de una sede cerrada:
    // el home vuelve a resolver la cobertura y decide con la información fresca.
    continueToClosedBranch() {
      track.trackEventCluvi(
        { supplier_id: this.closedBranch?.id },
        "set location.branch closed continue"
      );
      this.branchClosedAlert = false;
      trackBranchAssigned(this.closedBranch, "coverage", null);
      this.goHome(this.closedBranch?.slug);
    },
    goHome(slug) {
      if (!slug) return;

      this.$router.push({
        name: "Home",
        params: { supplier_id: slug }
      });
    },
    getLabelTranslation(item) {
      switch (item.target) {
        case "service_schedule":
          return `${this.$t("schedule")} ${this.getLabels("delivery")}`;
        case "service_table":
          return this.$t("service.select_popup.on_table_title", {
            category: this.instance.category_establishment
          });
        case "service_delivery":
          return this.getLabels("delivery_title");
        case "service_book":
          return this.$t("service.select_popup.book_title");
        case "service_take_away":
          return this.$t("service.select_popup.take_away_title", {
            category: this.instance.category_establishment
          });
        default:
          return item.label;
      }
    },
    sendEventLinktree(event) {
      track.trackEventCluvi({ search_term: event }, "ClickLinktree");
    },
    execILink(target) {
      this.sendEventLinktree(target);
      switch (target) {
        case "service_schedule":
          this.execSchedule();
          break;
        case "service_table":
          this.execOnTable();
          break;
        case "service_delivery":
          this.execDelivery();
          break;
        case "service_book":
          this.execBook();
          break;
        case "service_take_away":
          this.execTakeAway();
          break;
      }
    },
    handlePermission() {
      let self = this;
      if (navigator.permissions) {
        navigator.permissions
          .query({ name: "geolocation" })
          .then(function(result) {
            self.validateResult(result);
            result.onchange = function() {
              self.validateResult(result);
            };
          });
      }
    },
    validateResult(result) {
      if (result.state === "granted") {
        this.setAllowGps(true);
      }
    },
    closeActiveGps() {
      this.setAllowGps(true);
    },
    linkInstance() {
      try {
        if (this.instance.links.length === 1) {
          let link = this.instance.links[0];
          if (link.type === "on_table") this.execOnTable();
        }
      } catch (error) {
        error;
      }
    },
    routeToUrl() {
      if (this.instance.status === "locked") this.routeInactiveInstance();
      if (this.$route.name === "Location") this.routeLocationView();
    },
    routeLocationView() {
      this.setDelivery();
      this.$router.push({ name: "SetLocation" });
    },
    routeInactiveInstance() {
      this.$router.push({ name: "InactiveInstance" });
    },
    cleanOrder() {
      this.SetPurchaseId("");
      this.SetTaPurchaseId("");
      this.SetOtPurchaseId("");
      this.setCountProductsOrdered(0);
      this.setShoppingCart({
        total: 0,
        transaction_status: "precheckout"
      });
      this.SetTotalShoppingCart(0);
    }
  },
  mounted() {
    this.SetIsPreview(false);
    this.cleanOrder();
    try {
      setTimeout(() => this.SetLoading(false), process.env.VUE_APP_DELAY);
      track.trackView(this, `Main`, `/`);
      track.trackEventCluvi({}, "view main");
      this.handlePermission();
    } catch (error) {
      error;
      this.activeGps = true;
    }
  },
  metaInfo() {
    return {
      title: this.instance.name
    };
  }
};
</script>

<style scoped lang="scss">
.main-supplier-select {
  overflow-y: hidden !important;
  h2,
  h3 {
    text-align: center;
    color: white;
  }

  display: grid;
  min-height: 80vh;
  align-content: center;
  align-items: center;
  text-align: center;
}

.layout-img-logo {
  min-height: 10vh;
}

.linktree-logo {
  max-height: 20vh;
  max-width: 50vw !important;
}

.button-deliver-img {
  width: 100%;
  height: 56px !important;
}
</style>
